module.exports = __webpack_public_path__ + "static/img/12.e973d21c.jpg";